// Heartbeat authentifié → met à jour UserPresence (DB) avec la région courante.
// Extrait de app/page.tsx. `region` DOIT être dans les deps (sinon closure figée).
import { useEffect } from 'react'

export function useHeartbeat(sessionStatus: string, region: string) {
  useEffect(() => {
    if (sessionStatus !== 'authenticated') return
    const beat = () => fetch('/api/heartbeat', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ region }),
    }).catch(() => null)
    beat()
    const iv = setInterval(beat, 60_000)
    const onVisible = () => { if (document.visibilityState === 'visible') beat() }
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      clearInterval(iv)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [sessionStatus, region])
}
